export default __webpack_public_path__ + "static/media/facebook.8b26c61e.svg";